export const mealToMacroMap = (meal)=>{
	console.log(meal)
	const totalsMap = {
		carbs:{
			qty:0,
			unit:'g'
		},
		protein:{
			qty:0,
			unit:'g'
		},
		calories:{
			qty:0,
			unit:'kcal'
		},
		fat:{
			qty:0,
			unit:'g'
		},
		sodium:{
			qty:0,
			unit:'mg'
		},
		fiber:{
			qty:0,
			unit:'g'
		}
	}

	//total the standard macros from foods
	meal.foods.forEach((food)=>{
		//placeholders don't have macro data and are just UI indicators
		//that something is loading so don't try to run any calculation logic
		//on them otherwise they will cause a crash
		if (food.type === 'placeholder') return 
		const portion = food.portions.find(({id})=>(
			id === food.food_db_portion_id
		)) || food.portions[0]
		totalsMap.calories.qty += food.quantity * portion.calories
		totalsMap.protein.qty += food.quantity * portion.protein
		totalsMap.fat.qty += food.quantity * portion.fat
		totalsMap.carbs.qty += food.quantity * portion.carbs
		totalsMap.sodium.qty += food.quantity * portion.sodium
		totalsMap.fiber.qty += food.quantity * portion.fiber
		return totalsMap
	})

	//total custom macros
	if(Boolean(meal.recipe)&&Boolean(meal.recipe.use_custom_macros)){
		meal.recipe.macros.forEach(({macro,qty,unit})=>{
			//use lower case so that if a user defined something like
			//Carbs as a custom macro it will still total correctly 
			//with the all carbs
			macro = macro.toLowerCase().trim()
			if(!totalsMap[macro]){
				totalsMap[macro] = {qty:0,unit}
			}
			totalsMap[macro].qty+=qty
		})
	}
	return totalsMap
}

export const foodToMacroMap = (food)=>{
	const portion = food.portions.find(({id})=>(
		id === food.food_db_portion_id
	)) || food.portions[0]
	const qty = parseFloat(food.quantity)
	const map = {
		calories:{
			qty:portion.calories*parseFloat(qty),
			unit:'kcal'
		},
		carbs:{
			qty:portion.carbs*parseFloat(qty),
			unit:'g'
		},
		protein:{
			qty:portion.protein*parseFloat(qty),
			unit:'g'
		},
		fat:{
			qty:portion.fat*parseFloat(qty),
			unit:'g'
		},
		sodium:{
			qty:portion.sodium*parseFloat(qty),
			unit:'g'
		},
		fiber:{
			qty:portion.fiber*parseFloat(qty),
			unit:'g'
		}
	}
	return map
}

export const nutritionItemstoMacroMap = (items)=>{
	const map = {
		calories:{
			qty:0,
			unit:'kcal'
		},
		carbs:{
			qty:0,
			unit:'g'
		},
		protein:{
			qty:0,
			unit:'g'
		},
		fat:{
			qty:0,
			unit:'g'
		},
		sodium:{
			qty:0,
			unit:'mg'
		},
		fiber:{
			qty:0,
			unit:'g'
		}
	}
	items.forEach(item=>{
		switch(item.type){
			case "meal":
				const mealMacroMap = mealToMacroMap(item)
				Object.entries(mealMacroMap).forEach(([macro,{qty,unit}])=>{
					if(!Boolean(map[macro])){
						map[macro] = {
							qty:0,
							unit
						}
					}
					map[macro].qty += qty
				})
				break
			case "food":
				const foodMacroMap = foodToMacroMap(item)
				Object.entries(foodMacroMap).forEach(([macro,{qty,unit}])=>{
					if(!Boolean(map[macro])){
						map[macro] = {
							qty:0,
							unit
						}
					}
					map[macro].qty += qty
				})
				break
			default: 
				break
		}//end switch
	})
	return map
}